// extracted by mini-css-extract-plugin
export default {"unselectedTab":"linkTab_unselectedTab__gP9mu"};